import React from 'react';
import { UserCog } from 'lucide-react';
import { Banner, Button } from './ui';

const ImpersonationBanner: React.FC = () => {
  const impersonatedEmail = sessionStorage.getItem('impersonationActive');

  if (!impersonatedEmail) return null;

  const handleStop = () => {
    sessionStorage.removeItem('impersonationActive');
    window.close();
  };

  return (
    <div className="sticky top-0 z-50">
      <Banner
        tone="warning"
        icon={<UserCog className="h-5 w-5" aria-hidden="true" />}
        title="Impersonation aktiv"
        className="rounded-none"
        action={
          <Button variant="secondary" size="sm" onClick={handleStop}>
            Beenden
          </Button>
        }
      >
        Du siehst die App als: <strong>{impersonatedEmail}</strong>
      </Banner>
    </div>
  );
};

export default ImpersonationBanner;
